import { FC, useState } from 'react';
import { Formik, Field } from 'formik';
import Button from '../../GroupActions/Button';
import cx from 'classnames';
import styles from './SingleItem.module.scss';
import TextField from '../../Inputs/TextField';
import SelectField from '../../Inputs/SelectField';
import ToggleField from '../../Inputs/ToggleField';

export interface SingleItemProps {
  k: string;
  v: any;
  options: any;
  onDelete: (k: string) => void;
  tokenType: string;
  onChange: (v: any, k: string) => void;
}

const SingleItem: FC<SingleItemProps> = ({ k, v, options, onDelete, tokenType, onChange }) => {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <Formik
      initialValues={{ token_name: k, value: v, isReference: v.includes('var') }}
      // @ts-ignore
      onSubmit={(values) => {
        onChange(values.value, values.token_name);
        setIsEditing(false);
      }}
    >
      {({ values, handleSubmit }) => (
        <tr className={cx({ [styles['singleItem--editMode']]: isEditing })}>
          {/* <td>{!isEditing ? <div>{k}</div> : <TextField name='token_name' />}</td> */}
          <td>
            <div>{k}</div>
          </td>
          <td>
            {!isEditing ? (
              <div>{v}</div>
            ) : (
              <div className={styles.singleItem__valueInputWrapper}>
                <ToggleField name='isReference' label='Is Reference?' />
                {values.isReference ? <SelectField name='value' options={options} /> : <TextField name='value' />}
              </div>
            )}
          </td>
          <td>
            {(tokenType === 'color_ramps' || tokenType === 'color_palettes') && (
              <span className={styles['sample--colorSwatch']} style={{ backgroundColor: `var(${k})` }} />
            )}
            {tokenType === 'type' && (
              <span className={styles['sample--colorSwatch']} style={{ font: `var(${k})` }}>
                Aa
              </span>
            )}
            {tokenType === 'spacing' && (
              <span className={styles['sample--spacingSwatch']} style={{ width: `var(${k})` }} />
            )}
          </td>
          <td>
            {!isEditing ? (
              <>
                <Button icon='edit' onClick={() => setIsEditing(!isEditing)} variant='rounded' />
                <Button icon='trash' onClick={() => onDelete(k)} variant='rounded' />{' '}
              </>
            ) : (
              <>
                <Button icon='check' onClick={handleSubmit} variant='rounded' />
                <Button icon='close' onClick={() => setIsEditing(!isEditing)} variant='rounded' />
              </>
            )}
          </td>
        </tr>
      )}
    </Formik>
  );
};

export default SingleItem;
